<template>
  <div id="save-modal">
    <button
      :disabled=disabled
      @click="$emit('click')"
      type="button"
      class="button-primary button-save-modal ml-2 mr-2 pl-3 pr-3"
    >
      <span class="cta">
        <slot></slot> 
      </span>
    </button>
  </div>
</template>
<script>
export default {
  name: "save-modal",
  props: {
    disabled: {
      default: false,
      type: Boolean,
    }
  },
  emits: ["click"],
  data() {
    return {};
  },
  beforeMount() {},
  methods: {},
};
</script>
<style lang="scss">
#save-modal {
  
  .button-save-modal {
    background: #5d5fef !important;
    border-radius: 8px !important;
  }
}
</style>